import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import WeelodgeInfoContent from './WeelogeInfoContent';
import WeelodgeMetadata, {
  WEELODGE_STATUS,
} from '../proptype/weelodgeMetadata';
import WeelodgeHistoryItem from './WeelodgeHistoryItem';
import { formatDate } from '../../../services/utilityFunctions';

const WeelodgeSidebar = ({ t, onClose, info }) => {
  const { status } = info;
  const datePayment = info?.datePayment
    ? formatDate(info.datePayment, 'DD/MM/YYYY')
    : null;

  const dateAuthenticatedDeedSigned = info?.dateAuthenticatedDeedSigned
    ? formatDate(info.dateAuthenticatedDeedSigned, 'DD/MM/YYYY')
    : null;

  const dateAuthenticatedDeedPlanned = info?.dateAuthenticatedDeedPlanned
    ? formatDate(info.dateAuthenticatedDeedPlanned, 'DD/MM/YYYY')
    : null;

  const dateSignedBeforeContract = info?.dateSignedBeforeContract
    ? formatDate(info.dateSignedBeforeContract, 'DD/MM/YYYY')
    : null;

  const isConsideredAsPaid =
    status === WEELODGE_STATUS.PAID ||
    status === WEELODGE_STATUS.PAYMENT_RECEIVED ||
    status === WEELODGE_STATUS.INVOICED;
  return (
    <div>
      <button
        type="button"
        className="close-btn close-sidebar"
        onClick={onClose}
      >
        <i className="la la-close" />
      </button>
      {status && (
        <>
          <h5>{t('weelodge.modal.status')}</h5>
          <div className="status-container">
            <div
              className={`weelodge-status-badge weelodge-status-badge-${status}`}
            >
              <span>{t(`weelodge.modal.status.${status}`)}</span>
            </div>
          </div>
        </>
      )}
      {datePayment && isConsideredAsPaid && (
        <div className="paymentDate-container">
          <WeelodgeInfoContent
            label={t('weelodge.modal.paymentDate')}
            value={datePayment}
          />
        </div>
      )}
      <div className="history-container">
        <h4>{`${t('weelodge.modal.history')}:`}</h4>
        {dateAuthenticatedDeedSigned &&
          (status === WEELODGE_STATUS.SIGNED_DEED || isConsideredAsPaid) && (
            <div>
              <WeelodgeHistoryItem
                status={WEELODGE_STATUS.SIGNED_DEED}
                value={dateAuthenticatedDeedSigned}
              />
            </div>
          )}
        {dateAuthenticatedDeedPlanned && (
          <div className="history-full_treated">
            <WeelodgeHistoryItem
              status={WEELODGE_STATUS.FULL_TREATED}
              value={dateAuthenticatedDeedPlanned}
            />
          </div>
        )}
        {dateSignedBeforeContract && (
          <div className="history-contract">
            <WeelodgeInfoContent
              label={`${t('weelodge.modal.date.before_contract')}:`}
              value={dateSignedBeforeContract}
            />
          </div>
        )}
      </div>
    </div>
  );
};

WeelodgeSidebar.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  info: PropTypes.shape(WeelodgeMetadata.propType).isRequired,
};

WeelodgeSidebar.defaultProps = {};

export default translate(WeelodgeSidebar);
